<template>
  <div class="currency-dropdown" :class="{ 'is-open': isOpen, disabled }">
    <button
      type="button"
      class="currency-dropdown__toggle"
      @click="toggleDropdown"
      :disabled="disabled"
      :aria-expanded="isOpen.toString()"
      aria-haspopup="listbox"
    >
      <span>{{ selectedLabel }}</span>
      <span class="currency-dropdown__chevron"></span>
    </button>
    <transition name="fade">
      <ul
        v-if="isOpen"
        class="currency-dropdown__list"
        role="listbox"
        :aria-activedescendant="`currency-option-${selectedLabel}`"
      >
        <li
          v-for="option in options"
          :key="option"
          :id="`currency-option-${option}`"
          class="currency-dropdown__item"
          :class="{ active: option === selectedLabel }"
          role="option"
          tabindex="0"
          @click="selectOption(option)"
          @keydown.enter.prevent="selectOption(option)"
          @keydown.space.prevent="selectOption(option)"
        >
          {{ option }}
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CurrencyDropdown',
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    selectedLabel() {
      if (this.value && this.options.includes(this.value)) {
        return this.value;
      }
      return this.options[0] || '';
    }
  },
  methods: {
    toggleDropdown() {
      if (this.disabled || !this.options.length) {
        return;
      }
      this.isOpen = !this.isOpen;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    selectOption(option) {
      if (this.disabled) {
        return;
      }
      if (option !== this.value) {
        this.$emit('input', option);
        this.$emit('change', option);
      } else {
        this.$emit('change', option);
      }
      this.closeDropdown();
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.closeDropdown();
      }
    },
    handleKeyup(event) {
      if (event.key === 'Escape') {
        this.closeDropdown();
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keyup', this.handleKeyup);
  }
};
</script>

